import { useQuery } from '@tanstack/react-query';

import { AxiosError, AxiosResponse } from 'axios';

import { api } from '@/api';

type HomeParamsType = {
	page: number;
	row: number;
};

export type BannerItem = {
	file_pk: number;
	banner_enrollment_date: string;
	banner_pk: number;
	file_path: string;
	banner_title: string;
	banner_content: string;
};

export type BannerResponse = {
	banner: BannerItem[];
	banner_count: number;
};

export const useGetBannerApi = (params: HomeParamsType) => {
	const url = '/front/getBanner';
	return useQuery<AxiosResponse, AxiosError, BannerResponse>({
		queryKey: [url, params],
		queryFn: () => api.get(url, params),
		select: (res) => res.data.data,
	});
};
